import {Banner, Button, Link as PrimerLink} from '@primer/react'

import type {ReviewRequestBanner as ReviewRequestBannerData} from '../../page-data/payloads/header'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {Link} from '@github-ui/react-core/link'
import type {NavigationUrls} from '../../types/navigation-urls-types'

export function ReviewRequestBanner({
  reviewRequest,
  urls,
}: {
  reviewRequest: ReviewRequestBannerData
  urls: NavigationUrls
}) {
  /* eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags --
     TODO: Migrate to isFeatureEnabled from @github-ui/feature-flags. See
     https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
  const isChangesEnabled = useFeatureFlag('react_data_router_pull_request_files')
  const url = isChangesEnabled ? `${urls.changes}` : `${urls.files}`

  if (!reviewRequest.render) return null

  const message =
    reviewRequest.requestedBySelf || !reviewRequest.requestingUserDisplayLogin ? (
      'This pull request is waiting on your review.'
    ) : (
      <>
        <PrimerLink href={`/${reviewRequest.requestingUserDisplayLogin}`} className="Link--primary text-bold">
          {reviewRequest.requestingUserDisplayLogin}
        </PrimerLink>{' '}
        requested your review on this pull request.
      </>
    )

  return (
    <Banner
      aria-label="Review Request Banner"
      className="flex-row width-full"
      variant="warning"
      title="Review requested"
      layout="compact"
      hideTitle
      primaryAction={
        <Button as={Link} variant="primary" size="small" to={url} className="mr-1">
          Add your review
        </Button>
      }
    >
      <Banner.Description>{message}</Banner.Description>
    </Banner>
  )
}
